import React from "react";
import { string, func, number, oneOfType } from "prop-types";

import "./input.m.css";

const Input = ({ type, value, placeholder, onChange }) => {
  return <input type={type} value={value} placeholder={placeholder} onChange={onChange} styleName="input" />;
};

export default Input;

Input.propTypes = {
  type: string,
  value: oneOfType([string, number]),
  placeholder: string,
  onChange: func
};
